if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
  
          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
  
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  
          this.hideErrors = this.dataset.hideErrors === 'true';
        }
  
        async onSubmitHandler(evt) {  
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
          this.handleErrorMessage();
  
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          const submitLoadingSpinner = this.querySelector('.loading__spinner');
          if (submitLoadingSpinner) {
            submitLoadingSpinner.classList.remove('hidden');
          }
    
          //先添加搭售商品
          let reqForm = {};
          reqForm.items = [];
          
          // NOTE:
          // tying-products 的每一项结构是：
          // <li class="tying-product">
          //   {% form 'product', curProduct %}
          //     <input type="hidden" name="id" ...>
          //     ...
          //   {% endform %}
          // </li>
          //
          // 这里必须只拿【当前商品区域】里的 tying-products，
          // 不能全局 document 查询，否则会把别的 section / 推荐商品里的 tying-products 也算进来，
          // 导致“第一个勾选的”其实不是你当前看到的那个。
          const productContainer = this.closest('.mt-custom-product-container') || document;
          const tyingWrapper = productContainer.querySelector('.tying-products__wrapper');
          const tyingProductForms = tyingWrapper
            ? tyingWrapper.querySelectorAll('.tying-product form')
            : [];
          // 调试：打印一共找到了多少个 tying-product 表单，以及当前 product 容器
          console.log(
            '[tying-products] scope container id:',
            productContainer.id,
            'forms found:',
            tyingProductForms.length
          );

          Array.from(tyingProductForms).forEach((formItem, index) => {
            if(formItem.querySelector(".tying-product__check").checked){
              // Try to get variant ID from input field directly
              const idInput = formItem.querySelector('input[name="id"]');
              let variantId = null;
              
              if (idInput) {
                variantId = idInput.value;
              } else {
                // Fallback to FormData
                const formData = new FormData(formItem);
                variantId = formData.get("id");
              }
              
              // Only include id and quantity for Shopify Cart API, ensure id is integer
              if (variantId) {
                const parsedId = parseInt(variantId, 10);
                let item = {
                  id: parsedId,
                  quantity: 1
                };
                // Only add if id is a valid number
                if (!isNaN(item.id) && item.id > 0) {
                  // 调试：在控制台输出一下选中的 tying-product
                  const nameEl = formItem.closest('.tying-product')?.querySelector('.tying-product__name');
                  console.log('[tying-products] add item', {
                    index,
                    variantId: item.id,
                    name: nameEl ? nameEl.textContent.trim() : ''
                  });
                  reqForm.items.push(item);
                } 
              } 
            }
          });
          
          // 检查是否有 tying-product
          const hasTyingProducts = reqForm.items.length > 0;
          
          if(hasTyingProducts){
            // 设置标记，告诉 cart2.js 的拦截器不要自动打开购物车弹窗
            window.__addingTyingProducts = true;
            
            try {
              
              // Try adding items one by one using FormData format (like main product)
              const errors = [];
              for (let i = 0; i < reqForm.items.length; i++) {
                const item = reqForm.items[i];
                
                
                try {
                  // Use FormData format like the main product does
                  const formData = new FormData();
                  formData.append('id', item.id);
                  formData.append('quantity', item.quantity);
                  
                  const config = fetchConfig('javascript');
                  config.headers['X-Requested-With'] = 'XMLHttpRequest';
                  // 添加特殊标记，告诉拦截器这是批量添加的一部分
                  config.headers['X-Batch-Add'] = 'tying-products';
                  delete config.headers['Content-Type'];
                  config.body = formData;
                  
                  const formResponse = await fetch(`${routes.cart_add_url}`, config);
                  
                  if (!formResponse.ok) {
                    let errorData = {};
                    try {
                      errorData = await formResponse.json();
                    } catch (e) {
                      const errorText = await formResponse.text().catch(() => '');
                      try {
                        errorData = errorText ? JSON.parse(errorText) : {};
                      } catch (parseError) {
                        errorData = { description: errorText || 'Unknown error' };
                      }
                    }
                    errors.push({
                      item: item,
                      status: formResponse.status,
                      error: errorData
                    });
                  } else {
                    const responseData = await formResponse.json();
                  }
                } catch (error) {
                  errors.push({
                    item: item,
                    error: { message: error.message }
                  });
                }
              }
              
              if (errors.length > 0) {
                const firstError = errors[0];
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: firstError.item.id,
                  errors: firstError.error.errors || firstError.error.description,
                  message: firstError.error.message || firstError.error.description || 'Failed to add some bundle products',
                });
                this.handleErrorMessage(firstError.error.description || firstError.error.message || 'Failed to add some bundle products');
                // Don't stop the main product from being added, just log the error
                // this.error = true;
                // this.submitButton.classList.remove('loading');
                // this.submitButton.removeAttribute('aria-disabled');
                // this.querySelector('.loading__spinner').classList.add('hidden');
                // return;
              }
            } catch (error) {
              // Don't stop the main product from being added
              // this.handleErrorMessage('Failed to add bundle products');
              // this.error = true;
              // this.submitButton.classList.remove('loading');
              // this.submitButton.removeAttribute('aria-disabled');
              // this.querySelector('.loading__spinner').classList.add('hidden');
              // return;
            }
          }
          
          const mainLoadingSpinner = this.querySelector('.loading__spinner');
          if (mainLoadingSpinner) {
            mainLoadingSpinner.classList.remove('hidden');
          }
  
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
  
          const formData = new FormData(this.form);
          // 调试：主商品的变体 ID
          console.log('[main-product] add id', formData.get('id'));
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          
          // 如果有 tying-products，添加标记告诉拦截器这是批量添加的最后一步
          if (hasTyingProducts) {
            config.headers['X-Batch-Add'] = 'main-product';
          }
          
          config.body = formData;
  
          try {
            const response = await fetch(`${routes.cart_add_url}`, config);
            const responseData = await response.json();
            
            if (responseData.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: responseData.errors || responseData.description,
                message: responseData.message,
              });
              this.handleErrorMessage(responseData.description);
  
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) {
                this.submitButton.classList.remove('loading');
                const noSoldOutSpinner = this.querySelector('.loading__spinner');
                if (noSoldOutSpinner) {
                  noSoldOutSpinner.classList.add('hidden');
                }
                this.submitButton.removeAttribute('aria-disabled');
                this.error = true;
                return;
              }
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.submitButton.classList.remove('loading');
              const errorLoadingSpinner = this.querySelector('.loading__spinner');
              if (errorLoadingSpinner) {
                errorLoadingSpinner.classList.add('hidden');
              }
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
  
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            
            // 如果有 tying-product，等待所有产品都添加完成后再打开购物车抽屉
            if (hasTyingProducts) {
              // 等待一小段时间确保所有商品都已添加到购物车
              await new Promise(resolve => setTimeout(resolve, 500));
              
              // 重新获取最新的购物车数据，确保包含所有已添加的商品
              const cartSections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
              try {
                const cartResponse = await fetch(`${routes.cart_url}?sections=${cartSections}`);
                const cartHtml = await cartResponse.text();
                const parser = new DOMParser();
                const cartDoc = parser.parseFromString(cartHtml, 'text/html');
                
                // 构建包含最新购物车数据的响应对象
                const updatedResponse = {
                  ...responseData,
                  sections: {}
                };
                this.cart.getSectionsToRender().forEach((section) => {
                  const sectionElement = cartDoc.querySelector(`#${section.id}`);
                  if (sectionElement) {
                    updatedResponse.sections[section.id] = sectionElement.outerHTML;
                  } else {
                    // 如果找不到新的section，使用原来的数据
                    if (responseData.sections && responseData.sections[section.id]) {
                      updatedResponse.sections[section.id] = responseData.sections[section.id];
                    }
                  }
                });
                
                // 现在发布 cartUpdate 事件，使用最新的购物车数据
                if (!this.error) {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: updatedResponse,
                  });
                }
                
                // 打开购物车抽屉
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(updatedResponse);
                      }, 100);
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(updatedResponse);
                }
                
                // 清除标记
                window.__addingTyingProducts = false;
              } catch (fetchError) {
                // 如果获取最新数据失败，使用原来的响应数据
                console.warn('Failed to fetch updated cart data, using original response:', fetchError);
                
                // 发布 cartUpdate 事件
                if (!this.error) {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: responseData,
                  });
                }
                
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(responseData);
                      }, 100);
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(responseData);
                }
                
                // 清除标记
                window.__addingTyingProducts = false;
              }
            } else {
              // 没有 tying-product，正常处理
              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: responseData,
                });
              }
              
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(responseData);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(responseData);
              }
            }
          } catch (e) {
            console.error(e);
          } finally {
            this.submitButton.classList.remove('loading');
            const finallyLoadingSpinner = this.querySelector('.loading__spinner');
            if (finallyLoadingSpinner) {
              finallyLoadingSpinner.classList.add('hidden');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
        }
  
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
  
          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }
  